var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"radio-button"},[_c('input',{staticClass:"radio-button__button",attrs:{"type":"radio","name":_vm.name},domProps:{"value":_vm.value,"checked":_vm.checked},on:{"change":_vm.onChange}}),_c('div',{staticClass:"radio-button__content",class:( _obj = {}, _obj['radio-button__content_frame'] = _vm.isFrame, _obj )},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }